export abstract class BrowserNavigationService {
  abstract open(url: string, target?: '_blank' | '_self'): void;
}
